
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemesService {
  private static readonly DARK_THEME = 'avm-dark-theme';
  private static readonly LIGHT_THEME = 'avm-light-theme';

  private currentTheme = new BehaviorSubject<string>(ThemesService.DARK_THEME);
  public get currentTheme$() {
    return this.currentTheme.asObservable();
  }

  constructor(@Inject(DOCUMENT) private document: Document) {
    // Vérifie si un thème est déjà stocké (ex : sessionStorage)
    const storedTheme = sessionStorage.getItem('theme') as string;

    // Sinon, dark par défaut
    const initialTheme =
      storedTheme === ThemesService.LIGHT_THEME
        ? ThemesService.LIGHT_THEME
        : ThemesService.DARK_THEME;

    this.changeTheme(initialTheme);
  }

  /**
   * Applique un thème donné au <body>
   */
  changeTheme(theme: string | null = null) {
    if (
      theme !== ThemesService.DARK_THEME &&
      theme !== ThemesService.LIGHT_THEME
    ) {
      theme = ThemesService.DARK_THEME;
    }

    const body = this.document.body;
    body.classList.remove(ThemesService.DARK_THEME, ThemesService.LIGHT_THEME);
    body.classList.add(theme);

    this.currentTheme.next(theme);
    sessionStorage.setItem('theme', theme);
  }

  /**
   * Retourne le thème actuel
   */
  getCurrentTheme(): string {
    return this.currentTheme.value;
  }

  /**
   * True si le thème actif est sombre
   */
  isDarkTheme(): boolean {
    return this.getCurrentTheme() === ThemesService.DARK_THEME;
  }
}
